import o from"@razlet/ui/lib/modules/components/confirm-window/index.js";var e={name:"widget-bid-close-modal",components:{rzConfirmWindow:o},props:{isLoading:{type:Boolean,default:!1}}};export{e as default};
